/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SendTestWebpushNotificationMutationRequest,
  SendTestWebpushNotificationMutationResponse,
} from '../types/SendTestWebpushNotification.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSendTestWebpushNotificationUrl() {
  const res = { method: 'POST', url: `/notifications/test-webpush` as const };
  return res;
}

/**
 * @summary Send a test webpush notification to the current user's own subscriptions
 * {@link /notifications/test-webpush}
 */
export async function sendTestWebpushNotification(
  data: SendTestWebpushNotificationMutationRequest,
  config: Partial<RequestConfig<SendTestWebpushNotificationMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SendTestWebpushNotificationMutationResponse,
    ResponseErrorConfig<Error>,
    SendTestWebpushNotificationMutationRequest
  >({ method: 'POST', url: getSendTestWebpushNotificationUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
